//Déclaration des différentes routes de l'application
import Header from './containers/Layout/Header'
import * as modules from './containers/KeystoneMyOpenContainers'

function createDefaultPrivateRoute(path, main, title, exact) {
    return {
        path: path,
        exact: exact,
        main: main,
        header: Header,
        title: title,
    };
}

//Routes privées
export const privateRoutes = [
    createDefaultPrivateRoute('/', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/index.html', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/siteMonitorings', modules.SiteMonitorings, "Chantiers", true),
    createDefaultPrivateRoute('/siteMonitorings/siteMonitoring', modules.SiteMonitoring, "Suivi de chantier", true),
    
    createDefaultPrivateRoute(undefined, modules.NotFound, "Page 404", false),
];

//Routes publiques (pas besoin d'être identifié)
export const publicRoutes = [
    { path: '/Login', main: modules.Login },
    { path: '/NotFound', main: modules.NotFound },
    { path: '/ConfirmPasswordRenewal/:token', main: modules.ConfirmPasswordRenewal }
];
